/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable import/prefer-default-export */
/* eslint-disable no-console */
import { useFetch } from 'hooks/useFetch'
import React, { useMemo, useRef, useState, useEffect } from 'react'
import CollectionMap from 'components/CollectionMap'
import Modal from 'components/modal/Modal'
import { fetchCurrentAgent } from 'api/agents'
// import Switch from 'components/generic/formInputs/Switch/Switch'
// import clsx from 'clsx'
import s from './CollectionPage.module.css'
import { AgentBadge } from './components/AgentBadge'
import { ReadyToVisit } from './components/ReadyToVisit'
import { BookTour } from './components/BookTour'
import { PaginatedListing } from './components/PaginatedListing'
// import { SortBy } from './components/SortBy'
// import { Filter } from './components/Filter'

export function CollectionPage({ collectionId, signedIn }) {
  const [showBookTour, setShowBookTour] = useState(false)
  const [currentUser, setCurrentUser] = useState(undefined)
  // const [onlyLiked, setOnlyLiked] = useState(false)

  const closeModal = () => {
    setShowBookTour(false)
  }

  const showModal = () => {
    setShowBookTour(true)
  }

  useEffect(() => {
    fetchCurrentAgent().then((user) => {
      if (user.ok) {
        setCurrentUser(user.current)
      }
    })
  }, [])

  const { data, isLoading } = useFetch(collectionId ? `/api/v3/listing_collections/${collectionId}` : '')

  const listingIds = data?.listing_ids ? data?.listing_ids.map((id) => `ids[]=${encodeURIComponent(id)}`).join('&') : ''

  const { data: listings, isLoading: isLoadingListing } = useFetch(
    listingIds ? `/api/v3/listings/fetch.json?${listingIds}` : ''
  )

  const mapRef = useRef(null)

  const isAgent = data && data.created_by?.employee === true

  const activeListings = useMemo(
    () => (listings ? listings?.filter((listing) => listing.status === 'Available') : []),
    [listings]
  )

  const rentedListings = useMemo(
    () => (listings ? listings?.filter((listing) => listing.status === 'Rented') : []),
    [listings]
  )

  if (isLoading || isLoadingListing || !data) {
    return <div className={s.loading}>Loading...</div>
  }

  const listingsForMap = listings
    ? listings?.map((listing) => ({
        id: String(listing.id),
        latitude: listing.latitude,
        longitude: listing.longitude,
        address: listing.address,
        title: listing.short_address,
        image_url: listing.image?.medium,
        subtitle: listing.apartment,
        url: listing.listing_url,
      }))
    : []

  return (
    <>
      <div className={s.root}>
        <h1 className={s.title}>{data.name}</h1>

        <div className={s.container}>
          <div className={s.main}>
            <div className={s.header}>
              <div className={s.info}>
                <div className={s.infoTitle}>Active Listings</div>
                <div className={s.infoCounter}>{activeListings.length}</div>
              </div>

              {/* <div className={s.panel}>
                <Switch
                  className={s.onlyLikedSwitch}
                  value={onlyLiked}
                  onChange={setOnlyLiked}
                  afterText={
                    <span className={clsx(s.onlyLiked, onlyLiked && s.onlyLikedActive)}>Show only liked listings</span>
                  }
                />
                <Filter />
                <SortBy />
              </div> */}
            </div>

            <div className={s.listings}>
              <PaginatedListing
                data={activeListings}
                votes={data.votes}
                signedIn={signedIn}
                collectionId={collectionId}
              />
            </div>

            <div className={s.map}>
              <div className={s.header}>
                <div className={s.info}>
                  <div className={s.infoTitle}>Location</div>
                </div>
              </div>
              <div className={s.mapWrapper}>
                <CollectionMap ref={mapRef} points={listingsForMap} />
              </div>
            </div>

            {rentedListings.length > 0 && (
              <>
                <div className={s.header}>
                  <div className={s.info}>
                    <div className={s.infoTitle}>Rented Listings</div>
                    <div className={s.infoCounter}>{rentedListings.length}</div>
                  </div>
                </div>

                <div className={s.listings}>
                  <PaginatedListing
                    data={rentedListings}
                    votes={data.votes}
                    signedIn={signedIn}
                    collectionId={collectionId}
                  />
                </div>
              </>
            )}
          </div>

          {isAgent && (
            <div className={s.sidebar}>
              {data.created_by && <AgentBadge createdBy={data.created_by} onRequestTour={showModal} />}
            </div>
          )}
        </div>

        <ReadyToVisit
          agentAvatar={data.created_by?.avatar}
          agentName={data.created_by?.name}
          onRequestTour={showModal}
        />
      </div>

      <Modal
        className="modal-dialog request-tour-modal"
        closeTimeoutMS={150}
        isOpen={showBookTour}
        onRequestClose={closeModal}
      >
        <div className="modal-content">
          <BookTour type="listings" closeModal={closeModal} currentUser={currentUser} collectionId={collectionId} />
        </div>
      </Modal>
    </>
  )
}
